import React, { useContext } from 'react';
import { VariantValues, Price } from 'src/types';

type PriceListContextValue = {
  ourChoice?: Price | null;
  variantValues?: VariantValues | null;
};

export const PriceListContext = React.createContext<PriceListContextValue>({});

export const usePriceListContext = () => useContext(PriceListContext);
